import React, { useState } from "react";
import "./HomeMapSection.css";
import { useNavigate } from "react-router-dom";
import PackagesSection from "../PackagesSection/PackagesSection";
import { FiSearch } from "react-icons/fi";

const countries = [
  {
    name: "UAE",
    top: "64%",
    left: "60.5%",
    route: "/destination/uae",
    flag: "/assets/homepageicons/UAE.svg",
    pinIcon: "/assets/homepageicons/location-pin.png",
  },
  {
    name: "Qatar",
    top: "55%",
    left: "64.7%",
    route: "/destination/qatar",
    flag: "/assets/homepageicons/Qatar.svg",
    pinIcon: "/assets/homepageicons/location-pin.png",
  },
  {
    name: "India",
    top: "63.5%",
    left: "67.5%",
    route: "/destination/india",
    flag: "/assets/homepageicons/India.svg",
    pinIcon: "/assets/homepageicons/location-pin.png",
  },
  // {
  //   name: "Kazakhstan",
  //   top: "53%",
  //   left: "64%",
  //   route: "/destination/kazakhstan",
  //   flag: "/assets/homepageicons/Kazakhstan.svg",
  //   pinIcon: "/assets/homepageicons/location-pin.png",
  // },

  // Africa cluster (adjusted tighter grouping)
  {
    name: "Kenya",
    top: "73.5%",
    left: "58%",
    route: "/destination/kenya",
    flag: "/assets/homepageicons/Kenya.svg",
    pinIcon: "/assets/homepageicons/location-pin.png",
  },
  {
    name: "Uganda",
    top: "72%",
    left: "57%",
    route: "/destination/uganda",
    flag: "/assets/homepageicons/Uganda.svg",
    pinIcon: "/assets/homepageicons/location-pin.png",
  },
  {
    name: "Tanzania",
    top: "76.5%",
    left: "58%",
    route: "/destination/tanzania",
    flag: "/assets/homepageicons/Tanzania.svg",
    pinIcon: "/assets/homepageicons/location-pin.png",
  },
  {
    name: "Zambia",
    top: "78%",
    left: "56.4%",
    route: "/destination/zambia",
    flag: "/assets/homepageicons/Zambia.svg",
    pinIcon: "/assets/homepageicons/location-pin.png",
  },
  {
    name: "Zimbabwe",
    top: "81%",
    left: "56.5%",
    route: "/destination/zimbabwe",
    flag: "/assets/homepageicons/Zimbabwe.svg",
    pinIcon: "/assets/homepageicons/location-pin.png",
  },
  {
    name: "South Africa",
    top: "86%",
    left: "55.3%",
    route: "/destination/south-africa",
    flag: "/assets/homepageicons/South-Africa.svg",
    pinIcon: "/assets/homepageicons/location-pin.png",
  },

  // Southeast Asia cluster
  {
    name: "Malaysia",
    top: "72.5%",
    left: "73%",
    route: "/destination/malaysia",
    flag: "/assets/homepageicons/Malaysia.svg",
    pinIcon: "/assets/homepageicons/location-pin.png",
  },
  {
    name: "Singapore",
    top: "75%",
    left: "74%",
    route: "/destination/singapore",
    flag: "/assets/homepageicons/Singapore.png",
    pinIcon: "/assets/homepageicons/location-pin.png",
  },
];
const countries2 = [
  {
    name: "UAE",
    flag: "/assets/homepageicons/UAE.svg",
    bg: true,
  },
  {
    name: "Qatar",
    flag: "/assets/homepageicons/Qatar.svg",
    bg: true,
  },
  {
    name: "India",
    flag: "/assets/homepageicons/India.svg",
    bg: true,
  },
  {
    name: "Kenya",
    flag: "/assets/homepageicons/Kenya.svg",
    bg: true,
  },
  {
    name: "Uganda",
    flag: "/assets/homepageicons/Uganda.svg",
    bg: true,
  },
  {
    name: "Tanzania",
    flag: "/assets/homepageicons/Tanzania.svg",
    bg: true,
  },
  {
    name: "Zambia",
    flag: "/assets/homepageicons/Zambia.svg",
    bg: true,
  },
  {
    name: "Zimbabwe",
    flag: "/assets/homepageicons/Zimbabwe.svg",
    bg: true,
  },
  {
    name: "South Africa",
    flag: "/assets/homepageicons/South-Africa.svg",
    bg: true,
  },

  // Southeast Asia cluster
  {
    name: "Malaysia",
    flag: "/assets/homepageicons/Malaysia.svg",
    bg: true,
  },
  {
    name: "Singapore",
    flag: "/assets/homepageicons/Singapore.png",
    bg: true,
  },
  {
    name: "Saudi Arabia",
    flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/saudi_arabia.png",
  },

  {
    name: "Kazakhstan",
    flag: "https://flagcdn.com/w320/kz.png",
    bg: false,
  },

  {
    name: "Algeria",
    flag: "https://blueberrywebsites.azureedge.net/bbt/icons/CountryIcons/Algeria.png",
  },
  {
    name: "Angola",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/Angola.png",
  },
  {
    name: "Bamako",
    flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/Bamako.png",
  },
  {
    name: "Botswana",
    flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/Botswana.png",
  },
  {
    name: "Burkina",
    flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/Burkina.png",
  },
  {
    name: "Burundi",
    flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/Burundi.png",
  },
  // {
  //   name: "C.A.R",
  //   img: "https://blueberrywebsites.azureedge.net/bbt/images/CAR.png",
  // },
  { name: "Cameroon", flag: "https://flagcdn.com/w320/cm.png" },
  {
    name: "Comoros",
    flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/images/newImgs/countries/comoros.png",
  },
  { name: "Congo", flag: "https://flagcdn.com/w320/cg.png" },
  {
    name: "Gabon",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/Gabon.png",
  },
  {
    name: "Ghana",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/Ghana.png",
  },
  {
    name: "Guinea",
    flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/images/newImgs/countries/Guinea.jpg",
  },
  {
    name: "Ivory Coast",
    flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/Ivory.png",
  },

  {
    name: "Liberia",
    flag: "https://flagcdn.com/w320/lr.png",
  },
  {
    name: "Madagascar",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/Madagascar.png",
  },
  {
    name: "Malawi",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/Malawi.png",
  },
  {
    name: "Mozambique",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/Mazambique.png",
  },
  {
    name: "Namibia",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/Namibia.png",
  },
  {
    name: "Nigeria",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/Nigeria.png",
  },
  {
    name: "DRC",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/RDC.png",
  },
  {
    name: "Rwanda",
    flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/Rawanda.png",
  },
  {
    name: "Senegal",
    flag: "https://blueberrywebsites.azureedge.net/bbt/icons/CountryIcons/senegal.png",
  },
  {
    name: "Sierra Leone",
    flag: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/Flags/sierra.png",
  },

  {
    name: "Togo",
    flag: "https://blueberrywebsites.azureedge.net/bbt/images/Togo.png",
  },
];
const HomeMapSection = () => {
  const navigate = useNavigate();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const packagesSectionRef = React.useRef(null);

  const handleViewPackages = (country) => {
    setSelectedCountry(country.name);
    // Smooth scroll to packages section after state update
    setTimeout(() => {
      packagesSectionRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };
  const [searchTerm, setSearchTerm] = useState("");

  const filteredCountries = countries2.filter((country) =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  return (
    <>
      <section className="standard-padding map-section">
        <h1 className="heading mb-4">Our Global Footprint</h1>
        {/* NEW STATS SECTION */}
        <div className="map-stats">
          <div className="stat-item">
            <img src="/assets/homepageicons/map-icon1.svg" alt="world map" />
            <span>35+ Countries</span>
          </div>
          <div className="stat-divider">|</div>
          <div className="stat-item">
            <img src="/assets/homepageicons/map-icon2.svg" alt="world map" />
            <span> 13+ Years Of Experience</span>
          </div>
          <div className="stat-divider">|</div>
          <div className="stat-item">
            <img src="/assets/homepageicons/map-icon3.svg" alt="world map" />
            <span>400+ Clients</span>
          </div>
        </div>
        <div className="map-container">
          <div className="map-container-img">
            <img
              src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/contact%20us/World%20Map%20with%2011%20Location%20Pins.png"
              alt="world map"
              className="map-image"
            />
            {countries.map((country, index) => (
              <div
                key={index}
                className="map-pin"
                style={{ top: country.top, left: country.left }}
              >
                {/* Popup appears above pin on hover */}
                <div className="pin-popup">
                  <div className="pin-popup-header">
                    <img
                      src={country.flag}
                      alt={`${country.name} flag`}
                      className="popup-flag"
                    />
                    <span className="popup-country-name">{country.name}</span>
                  </div>
                  {/* <a
                  className="popup-link"
                  onClick={() => handleViewPackages(country)}
                >
                  View Packages
                </a> */}
                </div>

                {/* Yellow pulse dot */}
                <div className="pin-pulse">
                  {/* <img src="/assets/pin-pulse-img.svg" style={{ width: '100%' }} alt="/"></img> */}
                </div>
              </div>
            ))}
            <div className="activeDestination">DMC Active Destination <span className="activeDestination-dot"></span></div>
          </div>
          <div className="map-dropdown-div">
            <div className="map-search-box">
              <span className="search-icon">
                <FiSearch />
              </span>
              <input
                type="text"
                placeholder="Search by country..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

           <div className="country-list">
  {filteredCountries.length > 0 ? (
    filteredCountries.map((country, index) => (
      <div
        key={index}
        className="country-item"
      >
        <img
          src={country.flag}
          alt={country.name}
          className="country-flag"
        />
        <span>{country.name}</span>

        {country.bg && (
          <span
            className="flag-dot"
            style={{ backgroundColor: "#2EB13D" }}
          />
        )}
      </div>
    ))
  ) : (
    <div className="no-results">
      No countries found
    </div>
  )}
</div>
          </div>
        </div>
      </section>

      {/* Only render PackagesSection when a country is selected */}
      {/* {selectedCountry && (
        <div ref={packagesSectionRef}> */}
      {/* <PackagesSection/>
      //  country={selectedCountry}
      //   setCountry={setSelectedCountry} */}
    
      {/* </div>
      )} */}
    </>
  );
};

export default HomeMapSection;
